<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  ООО «Компания «Нипетойл» работает на топливно-нефтяном рынке с
                  2006 года. Основным видом деятельности является реализация и
                  поставка нефтепродуктов.
                </p>

                <p>
                  Доставка продукции осуществляется по Москве и Московской
                  области. Минимальный заказ начинается с 1 куб. м. или 1000 л.
                  Компания поставляет продукцию ПАО "Лукойл", ПАО "НК" Роснефть"
                  и ПАО "Газпром нефть" и других крупных
                  переработчиков.Менеджеры принимают заказы 24 часа в сутки, без
                  выходных. Вы можете заказать летнюю, зимнюю и арктическую
                  солярку, которая полностью соответствует ГОСТ (при наличии
                  такого на заказанный Вами продукт).
                </p>
                <p>
                  Также в наличии имеется дизтопливо для отопления в зданиях
                  любого типа. Нефтепродукты хранятся и транспортируются в
                  соответствии с принятыми нормами.
                </p>
                <p>
                  Доставку нефтепродуктов ООО «Компания «Нипетойл» осуществляет
                  как железнодорожным транспортом, так и бензовозами. Компания
                  имеет свой автопарт бензовозов емкостью от 1000 до 30 000
                  литров.
                </p>
                <p>
                  О стабильности компании говорит внушительное количество наших
                  клиентов, среди которых числится довольно много крупных
                  структурных подразделений и госпредприятий.
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:+74956403108"
                          class="ViewPromo__advantage-contact-link"
                          >+7 (495) 640-31-08</a
                        ></strong
                      >
                    </p>
                    <p>
                      Адрес электронной почты:<br />
                      <strong
                        ><a
                          href="mailto:ooo.nipetoil@gmail.com"
                          class="ViewPromo__advantage-contact-link"
                          >ooo.nipetoil@gmail.com</a
                        ></strong
                      >
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «Нипетойл»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1391,
    productId: 2167,
    name: 'ООО «Нипетойл»',
    inn: '7743595488 ',
  }),
};
</script>
